import { STATUS_NAMES } from "../lib/scenario";
import type { ScenarioRow } from "../lib/scenario";

export default function StatusChip({ row }: { row: ScenarioRow }) {
  const pending = row.scenario_change;
  return (
    <span className="chips">
      <span className={`chip ${row.status}`}>{STATUS_NAMES[row.status]}</span>
      {pending && (
        <span className={`chip ${pending.status}`}>
          {pending.status === "in-review" ? "Changes in review" : "Changes in draft"}
        </span>
      )}
      {row.sample && <span className="chip sample">Sample</span>}
    </span>
  );
}
